const vn = {
  salePrice: "Giá bán",
  maPrice: "Tổng giá trị vật liệu",
  finallyPrice: "lợi nhuận",
  PurePrice: "Lợi nhuận ròng",
  priceCheck: "Kế toán chi phí",

  save: "cứu",
  saveSuccess: 'Dữ liệu kế toán đã được cập nhật',
  saveError: 'Cập nhật dữ liệu kế toán không thành công',
  saveTip: 'Xác nhận lưu',
  saveTipContent: 'Lưu tỷ lệ ưu đãi/giảm giá và hoa hồng đã sửa đổi?',
  costUpdate: 'Dữ liệu kế toán chi phí có thay đổi',
  costUpdateTip: 'Bạn có chắc là bạn đã bỏ qua các thay đổi không?'
};

export default vn;